import { useEffect, useState } from 'preact/compat'
import { useDispatch } from 'react-redux'
import { API } from '../helpers/fetcher'
import {
  transactionDetailsClear,
  transactionDetailsUpdateAction,
} from '../redux/slice/transactionDetailsSlice'
import { componentsLoadUpdate } from '../redux/slice/pageStateSlice'

export default function useToken({ token }) {
  const dispatch = useDispatch()

  const [hasDetailsError, setDetailsError] = useState(false)

  useEffect(async () => {
    API.setToken(token)
    // A new token means the previous configuration is stale and a fresh
    // request is starting. Reset readiness BEFORE clearing details / dispatching
    // the replacement request, otherwise isConfigLoaded stays true from the
    // previous load while allowedPaymentMethods is cleared — reopening the
    // false-positive "no payment methods after filtering" race. See OPP monitor 8542454.
    dispatch(componentsLoadUpdate({ isConfigLoaded: false }))
    dispatch(transactionDetailsClear()) // reset the store
    dispatch(
      transactionDetailsUpdateAction({
        setDetailsError,
      }),
    )
  }, [token])

  return {
    hasDetailsError,
  }
}
